// extracted by extract-css-chunks-webpack-plugin
module.exports = {"addressOption":"address-suggestion-form__addressOption__e4LzJ"};